import Section from '../Section/Section'
import { defineMessages, useIntl } from 'react-intl'
import { ClientEventName, ClientEventSource, Listing } from '../../../../api/gqlaxy/gql/generated/graphql'
import { Badge, Flex, Text } from '@homebotapp/hb-react-component-catalog'
import { Waypoint } from 'react-waypoint'
import { useTrackingContext } from '../../../../providers/tracking'
import { useTrackingDebounceSetters } from '../../../../hooks/tracking'
import { LISTINGS_DETAILED, HOME_DETAILS } from '../../../../constants/tracking/trackingEventConstants'
import { useCreateClientEventOnView } from '../../../../hooks/useCreateClientEventOnView'

export const MSG = defineMessages({
  header: {
    id: 'HomeSearch.listingDetails.features',
    defaultMessage: 'Features'
  }
})

export interface HomeDetailsProps {
  listing?: Listing
}

export const HomeDetails = ({ listing }: HomeDetailsProps) => {
  const intl = useIntl()
  const { trackingClient } = useTrackingContext()
  const [trackModuleViewed] = useTrackingDebounceSetters(
    () =>
      trackingClient?.moduleViewed({
        event_source: LISTINGS_DETAILED,
        module_name: HOME_DETAILS
      })
  )
  const createModuleViewedClientEvent = useCreateClientEventOnView({
    eventName: ClientEventName.ModuleViewed,
    eventSource: ClientEventSource.ListingDetailed,
    location: HOME_DETAILS,
    listingId: listing?.id,
    eventProperties: {
      module_name: HOME_DETAILS
    }
  })

  const trackAmplitudeAndCreateClientEvent = () => {
    trackModuleViewed()
    createModuleViewedClientEvent()
  }

  if (
    !listing?.hasView &&
    !listing?.hasPool &&
    !listing?.hasGarage &&
    !listing?.hasBasement &&
    !listing?.hasFireplace &&
    !listing?.hasSpa &&
    !listing?.utilities
  ) {
    return null
  }

  return (
    <Section>
      <Section.Body>
        <Waypoint onEnter={trackAmplitudeAndCreateClientEvent} bottomOffset='25%' />
        <Text color='neutral-900' fontWeight='bold'>
          {intl.formatMessage(MSG.header)}
        </Text>
        <Flex gap={1} flex={1} flexWrap='wrap'>
          {listing?.hasView && <Badge key='View'>Great View</Badge>}
          {listing?.hasPool && <Badge key='Pool'>Pool</Badge>}
          {listing?.hasBasement && <Badge key='Basement'>Basement</Badge>}
          {listing?.hasGarage && <Badge key='Garage'>Garage</Badge>}
          {listing?.hasFireplace && <Badge key='Fireplace'>Fireplace</Badge>}
          {listing?.hasSpa && <Badge key='Spa'>Spa</Badge>}
          {listing?.utilities?.map(utility => <Badge key={utility}>{utility}</Badge>)}
        </Flex>
      </Section.Body>
    </Section>
  )
}
